<template>
  <div class="ql-editor" v-html="info.content"></div>
</template>

<script>
import { fetchDetail } from 'api/agreement'
export default {
  data () {
    return {
      info: {}
    }
  },
  created () {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail () {
      const res = await fetchDetail(this.$route.params.id)
      this.info = res
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
